import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEqual, find } from 'lodash';
import {Helmet} from 'react-helmet';
import moment from 'moment';
import { pdf as PDFRenderer }from '@react-pdf/renderer';
import CSV from '../../helpers/CSVExport';

import Box from '../../components/common/Box';
import ReactSelect from '../../components/common/ReactSelect';
import { territoriesActions } from '../../data/actions/territories';
import RollingMonthRevenue from '../../components/pages/territories/RollingMonthRevenue';
import ProductType from '../../components/pages/territories/ProductType';
import Countries from '../../components/pages/territories/Countries';
import Sources from '../../components/pages/territories/Sources';
import SharePage from '../../components/pages/sharedPages/SharePage';
import EntitiesList from '../../components/pages/home/EntitiesList';
import TerritoryStats from '../../components/common/Stats/Territory';
import PDFDocument from '../../components/pages/territories/PDFDetails';

const downloadSvg = require('!svg-inline-loader!../../../public/img/download.svg');
const pdfSvg = require('!svg-inline-loader!../../../public/img/pdf.svg');

class TerritoryDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			period: 'year',
		};
		this.exportToPdf = this.exportToPdf.bind(this);
	}
	
	componentDidMount() {
		this.props.dispatch(territoriesActions.getTerritories({...this.props}));
	}
	
	/*
	setPeriod({value: period}){
		this.setState({period}, ()=>{
			this.props.dispatch(territoriesActions.getTerritories(null, this.props.primaryCountries, this.state.period));	
		})
	}
	*/
	
	getExportTables(territories){
		const overview = territories.metrics.table.map(row=>{
			const {incomes, ...rest} = row;
			return rest;  
		}); 
		const countries = territories.metrics.table.map(row=>{
			const {incomes, period} = row;
			let result = {
				period
			};
			for(let country of incomes) {
				result[country.country_code] = country.income;
			}
			return result;
		}); 
		
		return {overview, countries}
	}

	exportToCsv = () => {
	  const {
		artists,
		projects,
		stats,
		territories
	  } = this.props;

	  const {overview, countries} = this.getExportTables(territories);

	  const data = [
	  	{ overview },
		{ countries },
		{ rolling_12_months_revenue: territories.months },  
		{ top_artists: artists.top },  
		{ top_projects: projects.top },
		{ territories: stats.territory.table },
	  ];
	  
	  const filename = CSV.CSVHeader('territories_report');

	  CSV.CSVBulkExport(data, filename);

	}
	
	getPdfData() {
		const reportTitle = 'Territories Report',
		{ 
			artists,
			projects,
			stats,
			territories
		} = this.props
			
		const imageIDs = [
			'top_territories_pie_chart',
		];
		let images = {};
		for (let imageID of imageIDs){
			let image = document.getElementById(imageID);
			if(image)
				images[imageID] = image.toDataURL("image/jpeg,1.0"); 
		}
		
		const {overview, countries} = this.getExportTables(territories);

		const tables = {
			overview,
			countries,
			rolling_12_months_revenue: territories.months,
			top_artists: artists.top,  
			top_projects: projects.top,
			territories: stats.territory.table
		};
		return { reportTitle, images, tables };
	}

	exportToPdf() {
		const data = PDFRenderer(<PDFDocument data={this.getPdfData()} />);
		data.toBlob()
		.then(blob=>{
			const fileURL = URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = fileURL;
			link.download = "Territories Report.pdf";
			link.click();
		});
	}
	

	render() {		
		const { sharedMode, continent, countries, selectedContinent, overrideGlobal } = this.props;
		const { dateStart, dateEnd, vendor, transactionType, physicalFormat, imprint } = this.props;
		const { metrics, loading } = this.props.territories;

		return <div className="territories-details-page">
			<div className="container">
				<div className="row download-page download-page--mt">
					<span>Export the data</span>
					<a key="download" title="Download entire page" onClick={this.exportToCsv} className="chart-icon download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
					<span>PDF</span>
					<a key="pdf" title="Download PDF" onClick={this.exportToPdf} className="chart-icon download-link" dangerouslySetInnerHTML={{__html: pdfSvg}} />
					{selectedContinent && <div className="form-group button-container">
						<SharePage entity={selectedContinent.name} module="territories" forceShow={true} CSVEntities={[]} flatCSVExport={true} overrideGlobal={overrideGlobal} />
					</div>}
				</div>    


				<div className="countries-holder">
						<Countries continent={continent} loading={loading} {...metrics} />
					{/* <div className="col-xs-8 pd-0 default">
					</div> */}
						<Sources {...metrics}  loading={loading} />
					{/* <div className="col-xs-4 pd-0 default">
					</div> */}
				</div>
				{/* <div className="row">
					<div className="col-xs-8 pd-0 default">
						<Countries continent={continent} loading={loading} {...metrics} />
					</div>
					<div className="col-xs-4 pd-0 default">
						<Sources {...metrics}  loading={loading} />
					</div>
				</div>   */}
				<div className="artist-top-tables artist-top-tables--double-columns">
					<EntitiesList trends={true} title="Top Projects" entity="projects" continent={continent} countries={countries} dateStart={dateStart} dateEnd={dateEnd} vendor={vendor} transactionType={transactionType} physicalFormat={physicalFormat} imprint={imprint} addTotal={true} externalLinks={!sharedMode} />
					<EntitiesList trends={true} title="Top Artists" entity="artists" continent={continent} countries={countries} dateStart={dateStart} dateEnd={dateEnd} vendor={vendor} transactionType={transactionType} physicalFormat={physicalFormat} imprint={imprint} addTotal={true} externalLinks={!sharedMode} />
				</div>
				<div className="row">
					<div className="col-xs-12 pd-0 default">
						<TerritoryStats continent={continent} dateStart={dateStart} dateEnd={dateEnd} countries={countries} loading={loading} showChart={false} vendor={vendor} transactionType={transactionType} physicalFormat={physicalFormat} imprint={imprint} ids={0} />
					</div>
				</div>    

				
				<div className="row">
					<div className="col-xs-12 pd-0 default">
						<RollingMonthRevenue filter={{...this.props}} />
					</div>
				</div>                        
				<Helmet>
					<title>Territories Details</title>
				</Helmet>
			</div>
		</div>
	}
}

function mapStateToProps(state) {
	return {
		territories: state.territories,
		filter: state.filter,
		stats: state.stats,
		artists: state.artists,
		projects: state.projects
	}
}

export default connect(mapStateToProps)(TerritoryDetails)
